import { Component, EventEmitter, Input, Output } from '@angular/core';

// Groups "member bar" (specs/ai-agent-home-redesign US-7, US-17): "All {label}" (last; selected at
// network scope) opens the full list dialog; the 2 inline buttons (first 2 groups, or the selected group
// swapped in) navigate directly.
@Component({
  selector: 'app-agent-groups-bar',
  templateUrl: './agent-groups-bar.component.html',
  styleUrls: ['./agent-groups-bar.component.scss'],
})
export class AgentGroupsBarComponent {
  @Input() networkName = '';
  @Input() groupsLabel = '';
  @Input() groups: any[] = [];
  @Input() currentGroupSlug = '';
  @Output() groupSelected = new EventEmitter<any>();
  @Output() openAll = new EventEmitter<void>();

  groupName(group: any): string {
    return group?.group_name || group?.name || '';
  }

  isActive(group: any): boolean {
    return !!group?.group_slug && group.group_slug === this.currentGroupSlug;
  }
}
